import { useQuery } from '@tanstack/react-query';
import type { ProjectDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ProjectApiResponse {
  success: boolean;
  data: ProjectDto;
}

/**
 * Hook to fetch a single project by ID, including its role and user shares.
 * Calls GET /projects/:id.
 * Disabled until a valid id is provided.
 */
export function useProject(id: number | undefined) {
  return useQuery({
    queryKey: queryKeys.projects.byId(id ?? 0),
    queryFn: async () => {
      const response = await apiClient.get<ProjectApiResponse>(`/projects/${id}`);
      return response.data.data;
    },
    enabled: id != null && id > 0,
  });
}
